import { useEffect, useState, ReactNode } from "react";

const ADMIN_CODE = "DRDEE2026!!";
const STORAGE_KEY = "drdee_admin_ok";

export default function AdminGate({ children }: { children: ReactNode }) {
  const [authed, setAuthed] = useState(false);
  const [code, setCode] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (sessionStorage.getItem(STORAGE_KEY) === "1") setAuthed(true);
  }, []);

  if (authed) return <>{children}</>;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (code === ADMIN_CODE) {
      sessionStorage.setItem(STORAGE_KEY, "1");
      setAuthed(true);
    } else {
      setError("Invalid code");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-sm space-y-4 rounded-2xl border border-border bg-card p-8 shadow-lg"
      >
        <h1 className="text-xl font-semibold text-center">Admin Access</h1>
        <p className="text-sm text-muted-foreground text-center">Enter the admin code to continue.</p>
        <input
          type="password"
          value={code}
          onChange={(e) => { setCode(e.target.value); setError(""); }}
          placeholder="Admin code"
          className="w-full rounded-lg border border-input bg-background px-4 py-2 outline-none focus:ring-2 focus:ring-ring"
          autoFocus
        />
        {error && <p className="text-sm text-destructive">{error}</p>}
        <button
          type="submit"
          className="w-full rounded-lg bg-primary py-2 font-medium text-primary-foreground hover:opacity-90 transition"
        >
          Unlock
        </button>
      </form>
    </div>
  );
}
